import $ from 'jquery';

$(function() {
    $('.collapse-container').each(function(){
        var _thisBlock = $(this),
            collapseBtn = _thisBlock.find('.collapse-btn');

        $(collapseBtn).on('click',  function(e) {
            let collapse = $(this).closest('.collapse');
            console.log(collapse)
            if (collapse.hasClass('active')) {
                collapse.toggleClass('active')
                collapse.children('.collapse-contents')
                    .slideUp('fast')
            } else {
                collapse.toggleClass('active')
                collapse.children('.collapse-contents').slideDown('fast')
            }
        })

    })
})
